import { useState } from "react";
import "./editorialForms.css";

const eventTypes = [
  { id: "concert", name: "Show/Concerto" },
  { id: "conference", name: "Conferência" },
  { id: "workshop", name: "Workshop" },
  { id: "party", name: "Festa" },
  { id: "sports", name: "Esportes" },
  { id: "exhibition", name: "Exposição" },
  { id: "theater", name: "Teatro" },
  { id: "festival", name: "Festival" },
  { id: "meetup", name: "Meetup" },
  { id: "other", name: "Outro" },
];

export default function EventForm({ data, onChange }) {
  const [ticketInput, setTicketInput] = useState({ type: "", price: "", quantity: "" });

  const handleAddTicket = () => {
    if (ticketInput.type.trim()) {
      onChange({
        ...data,
        tickets: [
          ...(data?.tickets || []),
          {
            type: ticketInput.type.trim(),
            price: parseFloat(ticketInput.price) || 0,
            quantity: parseInt(ticketInput.quantity) || 0,
            sold: 0,
            benefits: [],
          },
        ],
      });
      setTicketInput({ type: "", price: "", quantity: "" });
    }
  };

  const handleRemoveTicket = (index) => {
    onChange({
      ...data,
      tickets: (data?.tickets || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form event_form">
      <div className="editorial_form_section">
        <label>
          Nome do Evento <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Festival de Música 2024"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Detalhes do evento, atrações, programação..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={3000}
          rows={4}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Evento</label>
          <select
            value={data?.eventType || ""}
            onChange={(e) => onChange({ ...data, eventType: e.target.value })}
          >
            <option value="">Selecione</option>
            {eventTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Organizador</label>
          <input
            type="text"
            placeholder="Nome do organizador"
            value={data?.organizer || ""}
            onChange={(e) => onChange({ ...data, organizer: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Data de Início <span className="required">*</span>
          </label>
          <input
            type="datetime-local"
            value={data?.startDate?.slice(0, 16) || ""}
            onChange={(e) =>
              onChange({ ...data, startDate: new Date(e.target.value).toISOString() })
            }
          />
        </div>

        <div className="editorial_form_section">
          <label>Data de Término</label>
          <input
            type="datetime-local"
            value={data?.endDate?.slice(0, 16) || ""}
            onChange={(e) =>
              onChange({ ...data, endDate: new Date(e.target.value).toISOString() })
            }
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Local do Evento</label>
        <input
          type="text"
          placeholder="Nome do local"
          value={data?.venue || ""}
          onChange={(e) => onChange({ ...data, venue: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Endereço</label>
          <input
            type="text"
            placeholder="Rua, número, bairro"
            value={data?.address || ""}
            onChange={(e) => onChange({ ...data, address: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Cidade</label>
          <input
            type="text"
            placeholder="Cidade"
            value={data?.city || ""}
            onChange={(e) => onChange({ ...data, city: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Capacidade</label>
          <input
            type="number"
            placeholder="Número de pessoas"
            value={data?.capacity || ""}
            onChange={(e) =>
              onChange({ ...data, capacity: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Idade Mínima</label>
          <input
            type="number"
            placeholder="0"
            value={data?.ageRestriction || ""}
            onChange={(e) =>
              onChange({ ...data, ageRestriction: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isFree"
            checked={data?.isFree || false}
            onChange={(e) => onChange({ ...data, isFree: e.target.checked })}
          />
          <label htmlFor="isFree">Evento gratuito</label>
        </div>
      </div>

      {!data?.isFree && (
        <div className="editorial_form_section">
          <label>
            Ingressos
            <button
              type="button"
              className="add_variant_btn"
              onClick={handleAddTicket}
            >
              + Adicionar
            </button>
          </label>
          <div className="editorial_form_row" style={{ marginBottom: "8px" }}>
            <input
              type="text"
              placeholder="Tipo (VIP, Pista...)"
              value={ticketInput.type}
              onChange={(e) =>
                setTicketInput({ ...ticketInput, type: e.target.value })
              }
              style={{ flex: 2 }}
            />
            <input
              type="number"
              placeholder="Preço"
              value={ticketInput.price}
              onChange={(e) =>
                setTicketInput({ ...ticketInput, price: e.target.value })
              }
              min="0"
              step="0.01"
              style={{ flex: 1 }}
            />
            <input
              type="number"
              placeholder="Qtd"
              value={ticketInput.quantity}
              onChange={(e) =>
                setTicketInput({ ...ticketInput, quantity: e.target.value })
              }
              min="0"
              style={{ flex: 1 }}
            />
          </div>
          <div className="genre_chips">
            {(data?.tickets || []).map((ticket, i) => (
              <span
                key={i}
                className="genre_chip selected"
                onClick={() => handleRemoveTicket(i)}
                style={{ cursor: "pointer" }}
              >
                {ticket.type}: R${ticket.price} ({ticket.quantity} disp.) ×
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM9 10H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm-8 4H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2z" />
        </svg>
        <span>
          Adicione imagens atrativas do evento para aumentar o engajamento!
        </span>
      </div>
    </div>
  );
}
